/* eslint-disable camelcase */
export interface GrowthFiguresInt {
  refi_index: number | null
  change_week: number | null
  change_month: number | null
  change_quarter: number | null
  change_year: number | null
}

export const defaultFigures: GrowthFiguresInt = {
  refi_index: 0.0,
  change_week: 0.0,
  change_month: 0.0,
  change_quarter: 0.0,
  change_year: 0.0,
}

export const growthPeriods = {
  week: 'WEEK',
  month: 'MONTH',
  quarter: 'QUARTER',
  year: 'YEAR',
}
